import { withStyles } from "@material-ui/core/styles";
import DialogAddCanjeALote from "./DialogAddCanjeALote";
import styles from "./styles";
import { withNotificationContext } from "js/notification-context";

export default withNotificationContext(withStyles(styles)(DialogAddCanjeALote));
